"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DebugBar = DebugBar;
const React = __importStar(require("react"));
const react_jss_1 = require("react-jss");
const react_redux_1 = require("react-redux");
const useStyles = (0, react_jss_1.createUseStyles)({
    debugBar: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "end",
        alignItems: "center",
        fontSize: "12px",
        background: "rgba(0, 0, 0, 0.5)",
        padding: "4px 8px",
    },
    ping: {
        color: "#fff",
    },
});
function DebugBar() {
    const styles = useStyles();
    const network = (0, react_redux_1.useSelector)((state) => state.game.network);
    const [timeoutState, setTimeoutState] = React.useState(false);
    React.useEffect(() => {
        const interval = setInterval(() => {
            const timeSinceLast = Date.now() - network.lastPingTimestamp;
            if (timeSinceLast > 5000) {
                setTimeoutState(true);
            }
            else {
                setTimeoutState(false);
            }
        }, 1000);
        return () => {
            clearInterval(interval);
        };
    }, [network.lastPingTimestamp]);
    return (React.createElement("div", { className: styles.debugBar },
        React.createElement("span", { className: styles.ping }, timeoutState ? "XXX" : `${network.pingMs}ms`)));
}
